export const InputViewTestIdFactory = {
    getInputViewBase: () => 'input',
    getInputViewEndSlotButtonBase: () => 'end-button',
    getInputViewInputBase: () => [InputViewTestIdFactory.getInputViewBase(), 'input'].join('-'),
    // testid generators
    getInputViewContainerTestId: (componentPrefix, testId) => [
        componentPrefix,
        InputViewTestIdFactory.getInputViewBase(),
        'container',
        testId,
    ].join('-'),
    getInputViewLabelTestId: (componentPrefix, testId) => [
        componentPrefix,
        InputViewTestIdFactory.getInputViewBase(),
        'label',
        testId,
    ].join('-'),
    getInputViewDescriptionTestId: (componentPrefix, testId) => [
        componentPrefix,
        InputViewTestIdFactory.getInputViewBase(),
        'description',
        testId,
    ].join('-'),
    getInputViewInputTestId: (componentPrefix, testId) => [
        componentPrefix,
        InputViewTestIdFactory.getInputViewBase(),
        'input',
        testId,
    ].join('-'),
    getInputViewEndSlotButtonTestId: (componentPrefix, testId) => [
        componentPrefix,
        InputViewTestIdFactory.getInputViewBase(),
        InputViewTestIdFactory.getInputViewEndSlotButtonBase(),
        testId,
    ].join('-'),
};
